var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClouds2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 187,
    viewBox: "0 0 342 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_107_1533)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_107_1533",
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 11,
    width: 156,
    height: 95,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 171,
    y: 11,
    width: 156,
    height: 95
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.694 54.7334C282.694 56.1903 282.619 57.6297 282.473 59.048C286.982 55.1404 292.871 52.7748 299.314 52.7748C313.5 52.7748 325 64.242 325 78.3874C325 92.5329 313.5 104 299.314 104H199.462C199.455 104 199.448 104 199.441 104C199.435 104 199.428 104 199.421 104H199.29V104C184.757 103.918 173 92.1453 173 77.6341C173 63.1762 184.67 51.4363 199.13 51.27C200.896 29.8416 218.896 13 240.841 13C263.956 13 282.694 31.6847 282.694 54.7334Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.694 54.7334C282.694 56.1903 282.619 57.6297 282.473 59.048C286.982 55.1404 292.871 52.7748 299.314 52.7748C313.5 52.7748 325 64.242 325 78.3874C325 92.5329 313.5 104 299.314 104H199.462C199.455 104 199.448 104 199.441 104C199.435 104 199.428 104 199.421 104H199.29V104C184.757 103.918 173 92.1453 173 77.6341C173 63.1762 184.67 51.4363 199.13 51.27C200.896 29.8416 218.896 13 240.841 13C263.956 13 282.694 31.6847 282.694 54.7334Z",
    fill: "url(#paint0_linear_107_1533)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.473 59.048L280.483 58.8431L279.966 63.867L283.783 60.5594L282.473 59.048ZM199.29 104H197.29V106H199.29V104ZM199.29 104H201.29V102.011L199.301 102L199.29 104ZM199.13 51.27L199.153 53.2699L200.974 53.2489L201.123 51.4342L199.13 51.27ZM284.462 59.2529C284.615 57.7666 284.694 56.2588 284.694 54.7334H280.694C280.694 56.1217 280.623 57.4927 280.483 58.8431L284.462 59.2529ZM299.314 50.7748C292.372 50.7748 286.022 53.3254 281.163 57.5366L283.783 60.5594C287.942 56.9553 293.37 54.7748 299.314 54.7748V50.7748ZM327 78.3874C327 63.132 314.599 50.7748 299.314 50.7748V54.7748C312.401 54.7748 323 65.3519 323 78.3874H327ZM299.314 106C314.599 106 327 93.6428 327 78.3874H323C323 91.4229 312.401 102 299.314 102V106ZM299.314 102H199.462V106H299.314V102ZM199.441 106C199.445 106 199.449 106 199.453 106C199.456 106 199.459 106 199.462 106V102C199.458 102 199.454 102 199.45 102C199.447 102 199.444 102 199.441 102V106ZM199.421 106C199.424 106 199.427 106 199.43 106C199.433 106 199.437 106 199.441 106V102C199.439 102 199.436 102 199.432 102C199.429 102 199.425 102 199.421 102V106ZM199.421 102H199.29V106H199.421V102ZM201.29 104V104H197.29V104H201.29ZM171 77.6341C171 93.2515 183.651 105.912 199.279 106L199.301 102C185.862 101.925 175 91.0392 175 77.6341H171ZM199.107 49.2701C183.558 49.4489 171 62.074 171 77.6341H175C175 64.2784 185.782 53.4236 199.153 53.2699L199.107 49.2701ZM240.841 11C217.851 11 198.987 28.6439 197.137 51.1058L201.123 51.4342C202.804 31.0394 219.941 15 240.841 15V11ZM284.694 54.7334C284.694 30.5747 265.055 11 240.841 11V15C262.856 15 280.694 32.7947 280.694 54.7334H284.694Z",
    fill: "url(#paint1_linear_107_1533)",
    mask: "url(#path-1-outside-1_107_1533)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_107_1533)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2_107_1533",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 13,
    width: 255,
    height: 155,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 15,
    y: 13,
    width: 255,
    height: 155
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.882 84.0141C197.882 86.4233 197.758 88.8036 197.517 91.149C204.953 84.6871 214.664 80.7752 225.288 80.7752C248.68 80.7752 267.643 99.7383 267.643 123.13C267.643 146.523 248.68 165.486 225.288 165.486H60.6379C60.6256 165.486 60.6133 165.486 60.601 165.486C60.5887 165.486 60.5764 165.486 60.5641 165.486H60.3518V165.485C36.3863 165.351 17 145.882 17 121.885C17 97.9758 36.2441 78.5617 60.0878 78.2867C62.999 42.8508 92.6809 15 128.868 15C166.983 15 197.882 45.8987 197.882 84.0141Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.882 84.0141C197.882 86.4233 197.758 88.8036 197.517 91.149C204.953 84.6871 214.664 80.7752 225.288 80.7752C248.68 80.7752 267.643 99.7383 267.643 123.13C267.643 146.523 248.68 165.486 225.288 165.486H60.6379C60.6256 165.486 60.6133 165.486 60.601 165.486C60.5887 165.486 60.5764 165.486 60.5641 165.486H60.3518V165.485C36.3863 165.351 17 145.882 17 121.885C17 97.9758 36.2441 78.5617 60.0878 78.2867C62.999 42.8508 92.6809 15 128.868 15C166.983 15 197.882 45.8987 197.882 84.0141Z",
    fill: "url(#paint2_linear_107_1533)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.517 91.149L195.528 90.9447L195.011 95.9771L198.829 92.6586L197.517 91.149ZM60.3518 165.486H58.3518V167.486H60.3518V165.486ZM60.3518 165.485H62.3518V163.496L60.363 163.485L60.3518 165.485ZM60.0878 78.2867L60.1109 80.2866L61.932 80.2655L62.0811 78.4504L60.0878 78.2867ZM199.507 91.3534C199.755 88.9401 199.882 86.4916 199.882 84.0141H195.882C195.882 86.3549 195.762 88.667 195.528 90.9447L199.507 91.3534ZM225.288 78.7752C214.163 78.7752 203.991 82.8733 196.206 89.6395L198.829 92.6586C205.915 86.5008 215.164 82.7752 225.288 82.7752V78.7752ZM269.643 123.13C269.643 98.6337 249.785 78.7752 225.288 78.7752V82.7752C247.576 82.7752 265.643 100.843 265.643 123.13H269.643ZM225.288 167.486C249.785 167.486 269.643 147.627 269.643 123.13H265.643C265.643 145.418 247.576 163.486 225.288 163.486V167.486ZM225.288 163.486H60.6379V167.486H225.288V163.486ZM60.601 167.486C60.6079 167.486 60.6146 167.486 60.6207 167.486C60.6269 167.486 60.6324 167.486 60.6379 167.486V163.486C60.631 163.486 60.6242 163.486 60.6182 163.486C60.6119 163.486 60.6064 163.486 60.601 163.486V167.486ZM60.5641 167.486C60.5695 167.486 60.5751 167.486 60.5813 167.486C60.5873 167.486 60.5941 167.486 60.601 167.486V163.486C60.5956 163.486 60.59 163.486 60.5838 163.486C60.5778 163.486 60.571 163.486 60.5641 163.486V167.486ZM60.5641 163.486H60.3518V167.486H60.5641V163.486ZM62.3518 165.486V165.485H58.3518V165.486H62.3518ZM15 121.885C15 146.983 35.2756 167.345 60.3407 167.485L60.363 163.485C37.4971 163.357 19 144.781 19 121.885H15ZM60.0647 76.2868C35.1268 76.5744 15 96.879 15 121.885H19C19 99.0727 37.3614 80.5489 60.1109 80.2866L60.0647 76.2868ZM128.868 13C91.6312 13 61.0902 41.6581 58.0945 78.1229L62.0811 78.4504C64.9077 44.0436 93.7306 17 128.868 17V13ZM199.882 84.0141C199.882 44.7941 168.088 13 128.868 13V17C165.879 17 195.882 47.0033 195.882 84.0141H199.882Z",
    fill: "url(#paint3_linear_107_1533)",
    mask: "url(#path-3-outside-2_107_1533)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_107_1533",
    x: 156,
    y: 0,
    width: 186,
    height: 125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_107_1533"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_107_1533",
    result: "effect2_dropShadow_107_1533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_107_1533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_107_1533",
    x: 0,
    y: 2,
    width: 284.643,
    height: 184.486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_107_1533"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_107_1533",
    result: "effect2_dropShadow_107_1533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_107_1533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_1533",
    x1: 220.243,
    y1: 12.6205,
    x2: 256.625,
    y2: 104.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#9DDCFF",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_1533",
    x1: 244.07,
    y1: -18.512,
    x2: 294.338,
    y2: 141.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#85C6EC",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_1533",
    x1: 94.9027,
    y1: 14.3724,
    x2: 155.193,
    y2: 166.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#9DDCFF",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_1533",
    x1: 134.193,
    y1: -37.1111,
    x2: 217.515,
    y2: 227.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#85C6EC",
    stopOpacity: 0.71
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds2);
export default __webpack_public_path__ + "static/media/Clouds 2.78c87165667c6ee7c003e5d22f66737a.svg";
export { ForwardRef as ReactComponent };